import { useSelector, useDispatch } from 'react-redux';
import useScript from '../useScript';
import { iRootState, Dispatch } from '../redux/store';

const LoadCurrencyPayScript = function LoadCurrencyPayScript(): null {
  const currencyPayConfigIsLoaded = useSelector(
    (state: iRootState) => state.currencyPay.isLoaded
  );

  const dispatch = useDispatch<Dispatch>();
  const onLoad = (): void => {
    dispatch.currencyPay.scriptIsLoaded();
  };

  const useScriptArguments = {
    url: window.AutoQuotes.config.currencyPayScriptUrl,
    load: currencyPayConfigIsLoaded,
    onLoad
  };
  useScript(useScriptArguments);

  return null;
};

export default LoadCurrencyPayScript;
